import { FETCH_TOP_PRODUCTS_BY_CATEGORY, SET_IS_FETCHING_TOP_PRODUCTS } from 'reducers/actions-types';

export default function topProductsReducer(state = {
    isFetching: false,
    items: {},
}, { type, category, isFetching, products }) {
    let entries;

    switch (type) {
        case FETCH_TOP_PRODUCTS_BY_CATEGORY:
            entries = category.children.reduce((result, child, index) => {
                result[child.id] = products[index];
                return result;
            }, {});

            return Object.assign({}, state, {
                items: Object.assign({}, state.items, {
                    [category.id]: entries,
                }),
            });
        case SET_IS_FETCHING_TOP_PRODUCTS:
            return Object.assign({}, state, {
                isFetching,
            });
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/reducers/modules/top-products/index.js